module.exports = __webpack_public_path__ + "img/00001.c5ccbfec.webp";